import { setAllCartData} from '../../redux/checkoutredux/actions/cartactions/fetchdirectActions'; 
import store from '../../redux/checkoutredux/store/checkoutStore.ts';   //Todo-ips änderung ts js
// SC_ManageData.js


const CO_ManageData = {



  prepareFormData: () => {
    const selectedData = store.getState().selectedorderdata;
    const addressData = store.getState().addressdatacurrent.addressData;
    const additionalFormInput = store.getState().selectedorderdata.additionalforminput;

    // Bereiten Sie die Formulardaten vor
    let formData = {
      payment_method: selectedData.paymentdata && selectedData.paymentdata.id ? selectedData.paymentdata.id : '111',
      shipping_method: [selectedData.shippingdata.id],   //['flat_rate:5'], 
      ship_to_different_address: selectedData.deliverorpayaddressdata === 'delivery' ? false : true,
      bill_to_different_address: 'same_as_shipping',
      billing_first_name: addressData.firstName ? addressData.firstName : 'MAX', 
      billing_last_name: addressData.lasttName ? addressData.lastName : 'MUSTER', 
      billing_company: '', 
      billing_country: 'DE', 
      billing_address_1: 'adanaway 4', 
      billing_address_2: '', 
      billing_postcode: '48195', 
      billing_city: 'Hannover', 
      billing_state: '', 
      billing_phone: '026123',
      billing_email: 'heinz.elmann@mamp.pro', 
      shipping_address_type: 'regular', 
      shipping_first_name: 'Fern', 
      shipping_last_name: 'Johnson', 
      shipping_company: '',
      shipping_country: 'DE', 
      shipping_dhl_postnumber: '', 
      shipping_address_1: 'adanaway 4', 
      shipping_address_2: '', 
      shipping_postcode: '48195', 
      shipping_city: 'Hannover',
      shipping_state: '', 
      order_comments: '', 
      ips_update_cart: false,
    };




    let additionalFormData = {};

for (const key in additionalFormInput) {
  if (Object.hasOwnProperty.call(additionalFormInput, key)) {
    additionalFormData[key] = additionalFormInput[key];
  }
}

let combinedFormData = { ...formData, ...additionalFormData };


console.log("COMBINED ARRAY: ",combinedFormData);



    return combinedFormData;
  },





  checkSelectedShipping: (shippingcurrent, shippingmethods) => {
    let index = 0;
    let shippingblock = null;

    if (shippingcurrent && shippingmethods[shippingcurrent.index] && shippingmethods[shippingcurrent.index].method_id === 'local_pickup') {
      console.log("Ja, localpickup ist auf 00");
      // Wenn shippingcurrent auf "local_pickup" verweist und es eine Methode an der nächsten Position gibt
      if (shippingmethods[shippingcurrent.index + 1]) {
        console.log("Ja, localA_a true");
        index = shippingcurrent.index + 1;

        shippingblock = {
          index: index,
          methodid: shippingmethods[index].method_id,
          id: shippingmethods[index].id,
          title: shippingmethods[index].title,
          price: shippingmethods[index].pricewithtax
        };
  

        console.log("Shippingblock: ",shippingblock);

      } else {
        // Handle den Fall, wenn der Index außerhalb des Bereichs des Arrays liegt
        console.log("Index out of range or shippingmethods is undefined at index:", shippingcurrent.index + 1);
      }
    } else if (shippingcurrent && shippingmethods[shippingcurrent.index] && shippingmethods[shippingcurrent.index].method_id !== 'local_pickup') {
      
      

      if (shippingmethods[shippingcurrent.index]) {
        console.log("Ja, localA_b true");
        index = shippingcurrent.index;
      

        shippingblock = {
          index: index,
          methodid: shippingmethods[index].method_id,
          id: shippingmethods[index].id,
          title: shippingmethods[index].title,
          price: shippingmethods[index].pricewithtax
        };
  

        console.log("Shippingblock: ",shippingblock);

      } else {
        // Handle den Fall, wenn der Index außerhalb des Bereichs des Arrays liegt
        console.log("Index out of range or shippingmethods is undefined at index:", shippingcurrent.index + 1);
      }

      
      
      
      
    }else if(shippingcurrent == null || ( Object.keys(shippingcurrent).length === 0)){

      if(shippingmethods && shippingmethods[index].method_id === 'local_pickup'){

        if (shippingmethods[index + 1]) {
          console.log("Ja, localB_a true");
          index = index + 1;
  
          shippingblock = {
            index: index,
            methodid: shippingmethods[index].method_id,
            id: shippingmethods[index].id,
            title: shippingmethods[index].title,
            price: shippingmethods[index].pricewithtax
          };
    
        }
      }else{

        if (shippingmethods[index]) {
          console.log("Ja, localB_b true");
  
          shippingblock = {
            index: index,
            methodid: shippingmethods[index].method_id,
            id: shippingmethods[index].id,
            title: shippingmethods[index].title,
            price: shippingmethods[index].pricewithtax
          };


      }

      

    }




      // Andernfalls den Index von shippingcurrent verwenden oder 0, falls shippingcurrent nicht vorhanden ist
      //index = shippingcurrent ? shippingcurrent.index : 0;
      console.log("Shipping current is null");
    }
    
    console.log("Check Shipping:", index);
    

    //return index;

    return shippingblock;

    },





};

export default CO_ManageData;